// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "form.ts-submitting{pointer-events:none;opacity:.5}", "",{"version":3,"sources":["/Users/rlow/src/ctti/node_modules/ts-form/src/disable-during-submit.scss"],"names":[],"mappings":"AAAA,mBACE,mBAAA,CACA,UAAA","file":"disable-during-submit.scss","sourcesContent":["form.ts-submitting {\n  pointer-events: none;\n  opacity: 0.5;\n}"]}]);
// Exports
module.exports = exports;
